<template>
  <div id="PosWait" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 ">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">E</span>spera</div>
        <div class="col-3 f26 t-r color-primary" @click="app_select()" v-if="$store.state.account.account_grade >= 50"><i class="iconfont icon-modular"></i></div>
        <div class="col-3 f26 t-r color-primary" @click="app_exit()" v-else><i class="iconfont icon-exit"></i></div>
      </div>
    </div>
    <div class="h4"></div>
    <div class="col-12 t-c pt10 pb10">
      <img src="@/assets/cloud-service_5463868.png" class="r5 w15">
    </div>
    <div class="col-12 t-c pt10 pb10 lh22 f18 color-muted pl10 pr10">
      Póngase en contacto con nuestro servicio de atención al cliente para activar la función del servicio en la nube para usted.
    </div>
    <div class="col-12 pl10 pr10 t-c color-muted f18">
      Su nombre de usuario es <span class="fw color-black">{{ $store.state.account.user }}</span> y su dirección de correo electrónico es: <span class="fw color-black">{{ $store.state.account.email }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PosWait',
  data () {
    return {
      data_list: [],
      data_status: 0
    }
  },
  created: function () {
    this.check_status();
  },
  methods: {
    check_status(){
      var post_data = {};
      this.post(this.api_url + 'manage/account_wait', post_data).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAccount',res.data);
          this.$router.push({name:'Main'});
        }
      })
    },
    //APP选择页面
    app_select: function(){
      this.$router.push({name:'AppSelect'});
    },
    //APP退出
    app_exit: function(){
      this.$store.commit('setAccount',{});
      localStorage.setItem("token",'');
      this.$router.push({name:'Login'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/PosWait.vue